import { Checkbox, TableCell, TableRow } from "@mui/material";
import { ISystem } from "../../../../../../types/system";
import { IBranch } from "../../../../../../types/branch";
import { ISystemBranch } from "../../../../../../types/user";

type Props = {
    row: ISystemBranch;
    handleCheckboxChange: (row: ISystemBranch) => void;
    selectedItens: ISystemBranch[];
}

const UserUpdateSystemTableRow = ({ row, handleCheckboxChange, selectedItens }: Props) => {

    return (
        <>
            <TableRow hover>
                <TableCell padding="checkbox">
                    <Checkbox checked={selectedItens.some((systemBranch: ISystemBranch) => systemBranch.branchId === row.branchId && systemBranch.systemId === row.systemId)} onChange={() => handleCheckboxChange(row)} />
                </TableCell>                
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.branchCode}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.systemName}</TableCell>

            </TableRow>
        </>
    );

}

export default UserUpdateSystemTableRow;